module.exports = __webpack_public_path__ + "static/media/ImgMBTI_ROIC.6b41c9dd.png";